import React from 'react'
import styles from './HappenRow.module.scss'
import { FlexRow, FlexColumn } from 'components/common/Containers'
import Image from 'next/image'
import { H4 } from 'components/common/Texts/H4/H4'

interface Props {
  title: string
  desc: string
  imageSrc: string
  imageAlt: string
}

export const HappenRow: React.FC<Props> = ({title, desc, imageSrc, imageAlt}) => {
  return <FlexRow className={styles.content}>
    <Image
      className={styles.leftImage}
      width={283}
      height={283}
      src={imageSrc}
      alt={imageAlt}
    />
    <FlexColumn justify="center" className={styles.texts}>
      <H4 className={styles.title}>{title}</H4>
      <p className={styles.desc}>{desc}</p>
    </FlexColumn>
  </FlexRow>
};